import { useTranslation } from 'react-i18next';

import { Fields } from '../components/Fields/index.jsx';
import { BreakpointMobile } from '../constants/ui';
import { Header } from '../components/index.jsx';
import { useViewport } from '../hooks';
import { getSidebarLinksMap } from '../utils/ui';

const FieldsPage = () => {
  const { widthViewport } = useViewport();
  const { t } = useTranslation();
  const SidebarLinksMap = getSidebarLinksMap(t);

  return (
    <>
      {widthViewport > BreakpointMobile && <Header title={SidebarLinksMap.fields.title} t={t} />}
      <main className="main">
        <Fields t={t} />
      </main>
    </>
  );
};

export default FieldsPage;
